"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retry = void 0;
var MAX_RETRIES = 3;
var retry = function (func, numRetries) {
    if (numRetries === void 0) { numRetries = MAX_RETRIES; }
    if (!numRetries) {
        return func();
    }
    var internalRetry = function (fn, retries, error) {
        if (error === void 0) { error = null; }
        if (!retries) {
            return Promise.reject(error || new Error('Unknown error occured during retry'));
        }
        return fn().catch(function (err) { return internalRetry(fn, retries - 1, err); }); // eslint-disable-line no-magic-numbers
    };
    return internalRetry(func, numRetries);
};
exports.retry = retry;
//# sourceMappingURL=retry.js.map